import { CustomEbookBlock } from '../hooks/useCustomEbookReader';

export type QuestionType = 'radio' | 'checkbox';

export const getQuestionType = (block: CustomEbookBlock): QuestionType => {
  if (block?.qcm?.[0]?.type === 'checkbox') {
    return 'checkbox';
  }

  const firstOptionType = block?.qcm?.[0]?.response?.[0]?.typeReponse;
  if (firstOptionType === 'checkbox') {
    return 'checkbox';
  }

  if (Array.isArray(block.response_qcm_user)) {
    return 'checkbox';
  }

  return 'radio';
};

export const getSelectedQcmIds = (block: CustomEbookBlock): number[] => {
  const raw = block.response_qcm_user;

  if (Array.isArray(raw)) {
    return raw.map(id => Number(id)).filter(id => Number.isFinite(id) && id > 0);
  }

  if (raw === null || raw === undefined || raw === '') {
    return [];
  }

  const single = Number(raw);
  return Number.isFinite(single) && single > 0 ? [single] : [];
};

export const toStoredQcmUser = (
  questionType: QuestionType,
  selectedIds: number[],
): CustomEbookBlock['response_qcm_user'] => {
  if (questionType === 'checkbox') {
    return selectedIds.map(String);
  }

  return selectedIds[0] !== undefined ? String(selectedIds[0]) : '';
};

export const isQcmResponseSelected = (block: CustomEbookBlock, responseId: number): boolean =>
  getSelectedQcmIds(block).includes(responseId);

export const isOtherQcmOption = (typeReponse?: string): boolean =>
  typeReponse === 'text' || typeReponse === 'autre';
